import classNames from "classnames";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import SomeFacebookSquareLogoSvgInverted from "src/components/svg/SomeFacebookSquareLogoSvgInverted";
import SomeInstagramSquareLogoSvg from "src/components/svg/SomeInstagramSquareLogoSvg";
import SomeInstagramSquareLogoSvgInverted from "src/components/svg/SomeInstagramSquareLogoSvgInverted";
import SomeTikTokLogoSvg from "src/components/svg/SomeTikTokLogoSvg";
import SomeTikTokLogoSvgInverted from "src/components/svg/SomeTikTokLogoSvgInverted";
import styles from "./ArticleSoMeRow.module.css";

//#region [Props]
type ArticleSoMeRowProps = {
    className?: string;
    label: string;
};
//#endregion

//#region [Component]
export default function ArticleSoMeRow({ className, label }: ArticleSoMeRowProps) {
    return <div className={classNames(styles.SArticleSoMeRowContainer, className)}>
        <div className={classNames(styles.SLabel, "label")}>{label}</div>
        <FilmwebLink className={styles.SLink} to="https://www.facebook.com/filmweb.no" rel="noopener noreferrer">
            <SomeFacebookSquareLogoSvgInverted className={styles.SSomeFacebookSquareLogoSvg} />
        </FilmwebLink>
        <FilmwebLink className={styles.SLink} to="https://www.instagram.com/filmwebno/" rel="noopener noreferrer">
            <SomeInstagramSquareLogoSvgInverted className={styles.SSomeInstagramSquareLogoSvg} />
        </FilmwebLink>
        <FilmwebLink className={styles.SLink} to="https://www.tiktok.com/@filmweb.no" rel="noopener noreferrer">
            <SomeTikTokLogoSvgInverted className={styles.SSomeTikTokLogoSvg} />
        </FilmwebLink>
    </div>;
}
//#endregion

